import { validateError } from "~/utils";
import { toast } from "./index";

export const errorToast = (error?: unknown): void => {
  const message =
    typeof error === "string"
      ? error
      : validateError(error)?.response.data.error.message;

  toast({
    title: "Oops! That didn’t go quite as planned.",
    description:
      message ??
      "If it keeps happening, don’t hesitate to reach out — we’ve got you.",
    type: "error",
  });
};
